import { notification } from "antd";

/**
 * Adapter da API de toast do Chakra UI (removido do projeto) para o
 * notification do antd. Mantém a assinatura chamada em objActions.js:
 * toast({ title, description, status, duration (ms), position }).
 */
const PLACEMENTS = {
  "top-right": "topRight",
  "top-left": "topLeft",
  "bottom-right": "bottomRight",
  "bottom-left": "bottomLeft",
  top: "top",
  bottom: "bottom",
};

export function toast({
  title,
  description,
  status = "info",
  duration = 3500,
  position = "top-right",
}) {
  const method = status === "loading" ? "info" : status;
  notification[method]({
    message: title,
    description,
    duration: duration / 1000,
    placement: PLACEMENTS[position] || "topRight",
  });
}

export default toast;
